import companies from './companies.data';
const years = [1960, 1970, 1980, 1990, 2000, 2010, 2020];

export const getPercentageByCounts = counts => {
  const wholeCounts = years
    .map(item => getCountsByYears(item))
    .reduce((prev, cur) => prev + cur, 0);
  return Math.floor((counts / wholeCounts) * 100);
};

export const getCountsByYears = years => {
  return [...companies].filter(company => getYearsByYear(company.year) === years).length
};

export const getYearsByYear = year => {
  return years.find((curYears, index) => {
    const nextYears = years[index + 1];
    return nextYears ? nextYears > Number(year) : true
  });
};

export const getIndexByYear = year => {
  return years.findIndex(item => item === getYearsByYear(year));
};

export const getBlindValueByYears = targetYears => {
  switch (Number(targetYears)) {
    case years[0]: return 33;
    case years[1]: return 39;
    case years[2]: return 44;
    case years[3]: return 49;
    case years[4]: return 55;
    case years[5]: return 61;
    case years[6]: return 68;
    default: return null;
  }
};

export const getScriptsByYears = targetYears => {
  switch (Number(targetYears)) {
    case years[0]: return [
      ['1960_script_1_1,30,37,101', '1960_script_1_2,217,37,143'],
      ['1960_script_2_1,30,37,101', '1960_script_2_2,241,72,81', '1960_script_2_3,272,178,91'],
      ['1960_script_3_1,30,27,159', '1960_script_3_2,212,31,111', '1960_script_3_3,275,176,76'],
    ];
    case years[1]: return [
      ['1970_script_1_1,39,27,108', '1970_script_1_2,258,62,68'],
      ['1970_script_2_1,31,27,119', '1970_script_2_2,288,109,67'],
      ['1970_script_3_1,35,21,112', '1970_script_3_2,259,68,68'],
    ];
    case years[2]: return [
      ['1980_script_1_1,70,32,98', '1980_script_1_2,238,32,112'],
      ['1980_script_2_1,63,32,107', '1980_script_2_2,240,32,108'],
      ['1980_script_3_1,51,32,118', '1980_script_3_2,247,32,98'],
    ];
    case years[3]: return [
      ['1990_script_1_1,44,24,93', '1990_script_1_2,230,43,97', '1990_script_1_3,30,202,109'],
      ['1990_script_2_1,35,24,124', '1990_script_2_2,230,43,98', '1990_script_2_3,30,202,109'],
      ['1990_script_3_1,47,24,93', '1990_script_3_2,230,43,98', '1990_script_3_3,30,202,109'],
    ];
    case years[4]: return [
      ['2000_script_1_1,40,39,107', '2000_script_1_2,176,35,98', '2000_script_1_3,281,88,76'],
      ['2000_script_2_1,40,39,107', '2000_script_2_2,154,29,128', '2000_script_2_3,288,91,78'],
      ['2000_script_3_1,40,38,117', '2000_script_3_2,176,35,88', '2000_script_3_3,281,88,76'],
    ];
    case years[5]: return [
      ['2010_script_1_1,30,42,119', '2010_script_1_2,207,34,98'],
      ['2010_script_2_1,30,30,124', '2010_script_2_2,196,37,114', '2010_script_2_3,269,84,66'],
      ['2010_script_3_1,30,38,124', '2010_script_3_2,198,31,156', '2010_script_3_3,265,90,66'],
    ];
    case years[6]: return [
      ['2020_script_1_1,30,31,114', '2020_script_1_2,213,31,132', '2020_script_1_3,75,213,73'],
      ['2020_script_2_1,25,31,114', '2020_script_2_2,192,40,122', '2020_script_2_3,75,213,84'],
      ['2020_script_3_1,51,53,77', '2020_script_3_2,192,45,156', '2020_script_3_3,75,213,84'],
    ];
    default: return null;
  }
};

export default years
